var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13813",
    "data-name": "Group 13813",
    transform: "translate(-101 -209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    transform: "translate(101 209)",
    fill: "#fbe280",
    stroke: "#ffd571",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13812",
    "data-name": "Group 13812",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13811",
    "data-name": "Group 13811",
    transform: "translate(106.207 214.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13810",
    "data-name": "Group 13810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13809",
    "data-name": "Group 13809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M178.6,76.052a2.774,2.774,0,0,0-2.774-2.774h-9.56a6.385,6.385,0,0,0-6.385,6.385v7.089H182.4V79.764a2.774,2.774,0,0,0-2.774-2.774h-.094A.937.937,0,0,1,178.6,76.052Z",
    transform: "translate(-149.351 -73.278)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M291.855,76.988h-.094a.937.937,0,0,1-.937-.937,2.774,2.774,0,0,0-2.774-2.774H287V86.751h7.627V79.762A2.774,2.774,0,0,0,291.855,76.988Z",
    transform: "translate(-261.576 -73.277)",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M111.635,338.317a6.651,6.651,0,0,0-2.671-1.611l-8.19-2.593-8.947-.314-8.951.314-8.19,2.593a6.666,6.666,0,0,0-4.654,6.355V345.3A29.913,29.913,0,0,0,90.8,354.665,30.771,30.771,0,0,0,111.635,338.317Z",
    transform: "translate(-70.032 -303.269)",
    fill: "#4a80aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M249.117,376.044v-2.238a6.665,6.665,0,0,0-2.473-5.181,30.025,30.025,0,0,1-23.126,16.561,30.27,30.27,0,0,0,3.753.241,32.066,32.066,0,0,0,3.612-.209A29.923,29.923,0,0,0,249.117,376.044Z",
    transform: "translate(-205.53 -334.014)",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M210.626,338.573c1.815-3.6,6.542-13.836,5.194-20.228l-5.871-2.285-5.877,2.285c-1.389,6.589,3.676,17.259,5.353,20.542Q210.03,338.742,210.626,338.573Z",
    transform: "translate(-188.154 -287.609)",
    fill: "#e4f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M231.392,413.237l-2.381-9.365h-2.785l-2.375,9.34,2.936,3.269q1.118-.256,2.2-.593Z",
    transform: "translate(-205.826 -365.13)",
    fill: "#e28086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M244.942,499.3c.243.006.487.011.731.011.283,0,.565-.005.846-.013l1.513-1.671a29.765,29.765,0,0,1-3.669,1.029Z",
    transform: "translate(-223.934 -447.899)",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13807",
    "data-name": "Group 13807",
    transform: "translate(10.529 7.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13806",
    "data-name": "Group 13806",
    transform: "translate(6.248 17.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13805",
    "data-name": "Group 13805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13804",
    "data-name": "Group 13804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13803",
    "data-name": "Group 13803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13802",
    "data-name": "Group 13802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13801",
    "data-name": "Group 13801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13800",
    "data-name": "Group 13800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M223.223,288.4v-5.281H213.194V288.4c0,2.769,5.014,5.794,5.014,5.794S223.223,291.168,223.223,288.4Z",
    transform: "translate(-213.194 -283.117)",
    fill: "#f6b17e"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M182.4,142.451h-1.917a1.93,1.93,0,0,1-1.93-1.93v-1.056a2.038,2.038,0,0,0-2.677-1.935,15.093,15.093,0,0,1-9.471,0h0a2.038,2.038,0,0,0-2.677,1.935v1.057a1.93,1.93,0,0,1-1.93,1.93H159.88v3.157a1.461,1.461,0,0,0,1.461,1.461.48.48,0,0,1,.478.453,9.343,9.343,0,0,0,18.648,0,.48.48,0,0,1,.478-.453,1.461,1.461,0,0,0,1.461-1.461v-3.157Z",
    transform: "translate(-159.88 -137.424)",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M257.643,142.454a1.93,1.93,0,0,1-1.93-1.93v-1.056a2.038,2.038,0,0,0-2.677-1.935q-.546.181-1.1.317v10.426a9.341,9.341,0,0,1-4.655,7.94,9.333,9.333,0,0,0,10.344-8.692.48.48,0,0,1,.478-.453,1.461,1.461,0,0,0,1.461-1.461v-3.157h-1.917Z",
    transform: "translate(-237.036 -137.427)",
    fill: "#fbba8a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13808",
    "data-name": "Group 13808",
    transform: "translate(12.844 28.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M183.569,316.06l-3.933,3.2,4.124,5.1a1.366,1.366,0,0,0,1.829.07l3.1-2.591Z",
    transform: "translate(-179.636 -316.06)",
    fill: "#f4fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M261.807,316.06l-4.909,5.773,2.915,2.492a1.366,1.366,0,0,0,1.834-.053l4.095-5.017Z",
    transform: "translate(-247.844 -316.06)",
    fill: "#f4fbff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M164.711,316.06l-5.772,2.836a.874.874,0,0,0-.392,1.186l1.131,2.193a1.468,1.468,0,0,1-.267,1.712l-.7.7a1.465,1.465,0,0,0-.359,1.493c1.365,4.162,7.937,10.527,10.423,12.829q.251.007.5.009C167.47,335.512,161.08,322.185,164.711,316.06Z",
    transform: "translate(-147.934 -287.609)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M269.729,323.986a1.468,1.468,0,0,1-.267-1.712l1.131-2.193a.874.874,0,0,0-.392-1.186l-5.772-2.836c3.63,6.124-2.756,19.445-4.561,22.957q.255,0,.508-.013c2.492-2.308,9.052-8.665,10.417-12.823a1.465,1.465,0,0,0-.359-1.493Z",
    transform: "translate(-237.621 -287.609)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M233.892,365.327l-3.054,2.55,1.556,1.967h2.785l1.556-2.083Z",
    transform: "translate(-211.994 -331.102)",
    fill: "#dd636e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDummy);
export default __webpack_public_path__ + "static/media/profile-dummy.e6bd4b043398125354251f1b5217abb7.svg";
export { ForwardRef as ReactComponent };